<template>
    <div style="display: flex; flex-direction: column; align-items: flex-end">
        <div class="d-flex">
            <management-button
                v-if="isTaskBlocked"
                class="map-button"
                type="execute"
                :label="$t('Show Message')"
                @buttonClick="showErrorMsg"
            />
            <management-button
                v-if="taskDecisionButtons || isTaskBlocked"
                class="map-button"
                type="execute"
                :label="$t('Submit')"
                @buttonClick="submit"
                :disabled="taskDecisionButtons ? taskContents.length !== list.length : !(taskContents.length > 0)"
            />
        </div>
        <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page-text="rowsPerPageText"
            :items-per-page-items="allRows ? allRows : rowsPerPageItems"
            :no-data-text = "$t('AddToTable')"
            :header-props="{ sortIcon }"
            :footer-props="{ prevIcon, nextIcon }"
            class="elevation-2"
            :style="[
                taskDecisionButtons ? { 'margin-top': '10px' } : { 'margin-top': '0' }
            ]"
        >
            <template v-slot:item="props">
                <tr @click="showDialog(props.item.type,props.item)">
                <td class="text-xs-left">
                    <v-icon v-if="props.item.blocked" color="error">
                        priority_high
                    </v-icon>
                    {{ props.item.label }}
                </td>
                <td class="text-xs-left">{{ props.item.type }}</td>
                <td class="text-xs-left">{{ props.item.required ? 'True' : 'False'}}</td>
                <td class="text-xs-left">{{ Number(props.item.index) }}</td>
                <td class="text-xs-left">{{checkStepValue(props.item.type, props.item.value)}}</td>
                <td class="text-xs-left">
                    <app-datatable-action-buttons
                        v-if="!editionDisabled"
                        :user-can-edit="true"
                        @edit="$emit('editItem', props.item)"
                        :user-can-delete="true"
                        @delete="$emit('removeItem', props.item)"
                    />
                </td>

                <td v-if="taskManagement">
                    <task-decision-buttons
                        v-if="taskDecisionButtons || isTaskBlocked"
                        @approve="
                            $emit('updateTaskContents', {
                            decision: 'approve',
                            uuid: props.item.uuid
                            })
                        "
                        @reject="
                            $emit('updateTaskContents', {
                            decision: 'reject',
                            uuid: props.item.uuid
                            })
                        "
                        :isTaskBlocked="isTaskBlocked"
                        :uuid="props.item.uuid"
                        :taskContents="taskContents"
                    />
                </td>
                </tr>
            </template>
            <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
                {{ props.itemsLength }}
            </template>
        </v-data-table>
        <photo-view
            :dialog="photoDialog"
            :imageData="dialogData"
            @close="closeImageView($event)"
            @updateTaskContents="$emit('updateTaskContents', $event)"
            :taskContents="taskContents"
            :taskDecisionButtons="!taskDecisionButtons"
        />
        <text-message :textDialog="textDialog" :text="textMsg" @closeTextDialog="closeTextDialog"/>
        <app-dialog-box
            :open="rejectDialog"
            :title="$t('RejectTask')"
            :content="$t('RejectionMessage') + '*'"
            :main-action-label="$t('Cancel')"
            @mainAction="cancelRejection"
            :secondary-action-label="$t('Reject')"
            :secondary-action-disable="rejectionMessage.trim().length !== 0"
            @secondaryAction="rejectTask"
            :loading="loadingDelete"
        >
            <div slot="dialog-textbox" class="rejection-message-textarea">
                <textarea
                    v-model="rejectionMessage"
                    class="input-field"
                    maxlength="1024"
                />
                <label>{{ $t("RejectionNote") }}</label>
            </div>
        </app-dialog-box>
    </div>
</template>
<script>
import managementButton from "@/components/Management/ManagementButton";
import TaskDecisionButtons from "@/components/FieldManagement/FieldWork/Data/TaskDecisionButtons";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import PhotoView from "../../../../../../FieldManagement/FieldWork/Data/TaskType/PhotoView.vue";
import TextMessage from "../../../../../../FieldManagement/FieldWork/Data/TaskType/TextMessage.vue";
export default {
    name: "MixedTable",
    mixins: [activitiesTasksDataMixin, managementDatatableMixin],
    components: {
        managementButton,
        TaskDecisionButtons,
        AppDatatableActionButtons,
        AppDialogBox,
        PhotoView,
        TextMessage
    },
    props:{
        list: {
            type: Array
        },
        allRows: {
            type: Array
        },
        taskDecisionButtons: {
            type: Boolean,
            default: false
        },
        taskContents: {
            type: Array
        },
        editionDisabled: {
            type: Boolean,
            default: true
        },
        taskManagement: {
            type: Boolean,
            default: false
        },
        isTaskBlocked:{
            type: Boolean,
            default: false
        },
        blockMessage:{
            type: String,
        }
    },
    computed: {
      headers() {
          let headers;
            if (this.taskManagement) {
                headers = [
                    {
                        text: `${this.$i18n.tc("Label")}`,
                        value: "label",
                        width: "28%"
                    },
                    {
                        text: `${this.$i18n.tc("Type")}`,
                        value: "type",
                        width: "12%"
                    },
                    {
                        text: `${this.$i18n.tc("Required")}`,
                        value: "required",
                        width: "12%"
                    },
                    {
                        text: `${this.$i18n.tc("Index")}`,
                        value: "index",
                        width: "12%"
                    },
                    {
                        text: `${this.$i18n.tc("Value")}`,
                        value: "value",
                        width: "12%"
                    },
                    {
                        text: "",
                        value: "action",
                        sortable: false,
                        width: "12%"
                    },
                    {
                        text: "",
                        value: "decision",
                        sortable: false,
                        width: "12%"
                    }
                ];
            }else{
                headers = [
                    {
                        text: `${this.$i18n.tc("Label")}`,
                        value: "label",
                        width: "28%"
                    },
                    {
                        text: `${this.$i18n.tc("Type")}`,
                        value: "type",
                        width: "15%"
                    },
                    {
                        text: `${this.$i18n.tc("Required")}`,
                        value: "required",
                        width: "15%"
                    },
                    {
                        text: `${this.$i18n.tc("Index")}`,
                        value: "index",
                        width: "12%"
                    },
                    {
                        text: `${this.$i18n.tc("Value")}`,
                        value: "value",
                        width: "15%"
                    },
                    {
                        text: "",
                        value: "action",
                        sortable: false,
                        width: "15%"
                    }
                ];
            }
            return headers;
        },
    },
    data(){
        return{
            rejectDialog: false,
            rejectionMessage: "",
            loadingDelete: false,
            photoDialog: false,
            textDialog: false,
            textMsg: "",
            dialogData: [],
        }
    },
    methods: {
        checkStepValue(taskType, value){
            switch (taskType) {
                case "photo":
                    return value ? 'True' : 'Empty'
                case "text":
                    return value ? value : 'Empty'
                default:
                    return value;
            }
        },
        cancelRejection() {
            this.rejectDialog = false;
            this.rejectionMessage = "";
        },
        rejectTask() {
            this.$emit("rejectTask", this.rejectionMessage);
            this.cancelRejection();
        },
        submit() {
            if(this.taskContents.filter(item => item.decision === "reject").length > 0) {
                this.rejectDialog = true;
            } else {
                this.$emit("approveTask");
            }
        },
        showDialog(taskType, task){
            if(this.taskManagement){
                switch (taskType) {
                    case 'photo':
                        this.dialogData = task;
                        this.photoDialog = true;
                        break;
                    case 'text':
                        this.textDialog = true;
                        this.textMsg = task.value;
                        break;
                    default:
                        break;
                }
            }
        },
        showErrorMsg(){
            this.textDialog = true;
            this.textMsg = this.blockMessage;
        },
        closeImageView(closeImage) {
            this.photoDialog = closeImage;
            this.dialogData = [];
        },
        closeTextDialog(){
            this.textDialog = false;
            this.textMsg = "";
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Mixed/MixedTable.vue